import { useEffect } from "react";
import { AdvanceLinkStore, AdvanceStore, MeasurementStore } from "store";
import { lang } from "../../i18nLang";
import DialogModal from "../UI/DialogModals";
import InstallmentsTableLink from "../shared/Installments/TableLink/TableLink";
const label = "advances.linkModal";
interface IProps {
  /** Propriedade que indica se o modal está aberto ou fechado. */
  open: boolean;
  /** Função que será chamada ao fechar o modal */
  onClose: () => void;
}
/** Formulário para vincular parcelas de adiantamentos a medição atual.
 * @category Components
 */
const AdvanceLink = (props: IProps) => {
  const measurement = MeasurementStore.currentMeasurement;

  useEffect(() => {
    AdvanceStore.addAdvancesListObserver();
    return () => {
      AdvanceStore.removeObserver();
    };
  }, []);

  useEffect(() => {
    if (props.open) {
      AdvanceLinkStore.reset();
      AdvanceLinkStore.getCurrentLinks();
    }
  }, [props.open]);

  const handleConfirm = async () => {
    return await AdvanceLinkStore.updateAdvancesLinkWithMeasurement();
  };

  const handleSelectInstallment = (advanceId, installmentId, checked) => {
    if (checked) {
      AdvanceLinkStore.addItemToAdvanceLink(advanceId, installmentId);
    } else {
      AdvanceLinkStore.removeItemFromAdvanceLink(advanceId, installmentId);
    }
  };

  return (
    <DialogModal
      title={lang(`${label}.title`)}
      open={props.open}
      onClose={props.onClose}
      confirmLabel={lang("link")}
      onConfirm={handleConfirm}
      disabledConfirm={!measurement?.canEdit()}
      maxWidth="md"
    >
      <InstallmentsTableLink
        store={AdvanceLinkStore}
        onSelectInstallment={handleSelectInstallment}
        notFoundMessage={{
          title: lang(`${label}.notFound.title`),
          subtitle: lang(`${label}.notFound.subtitle`),
          trail: lang(`${label}.notFound.trail`),
        }}
      />
    </DialogModal>
  );
};
export default AdvanceLink;
